<template>
 
    <main>
           <v-breadcrumbs :items="breadCrumbs" large></v-breadcrumbs>
        <div>

            <v-form>
                <v-row>
                    <v-card class="pa-10" id="form_card" width="100%">
                        <v-row>
                            <v-col cols="12" sm="4">

                                <div>
                                    <div class="employee-form-header">
                                        <span>{{$t('department')}}</span>
                                    </div>
                                    <div>
                                        <v-autocomplete :items="listDDLData.departmentList"
                                                        item-text="value"
                                                        item-value="id"
                                                        :label="$t('department')"
                                                        required dense outlined
                                                        v-model="logData.departmentID">
                                        </v-autocomplete>
                                    </div>

                                </div>
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-row>

                                    <v-col>
                                        <v-btn @click="updateData()" color="blue darken-4" dark v-if="logData.departmentID !='NAN'">
                                            {{$t('assignForm')}}
                                        </v-btn>

                                        <v-btn @click="reset" class="ml-2" color="blue darken-4" dark>{{$t('reset')}}</v-btn>
                                    </v-col>
                                </v-row>
                            </v-col>

                        </v-row>
                    </v-card>
                </v-row>
            </v-form>
        </div>
        <v-dialog max-width="1000px" v-model="dialogRow">

            <AssignComponent :key="count" :logResponseData="logData" @formResponse="onResponse"></AssignComponent>
        </v-dialog>


        <v-dialog max-width="1000px" v-model="dialogEditRow">

            <v-card>


                <v-toolbar class="darken-4" color="indigo" dark>
                    <v-toolbar-title>
                        {{$t('rowshowhide')}}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-btn @click="onResponse" dark text>
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar-items>
                </v-toolbar>
                <v-card-text>
                    <v-container>
                        <form>

                            <v-expansion-panels multiple>
                                <v-row>

                                    <v-col :key="sectionData.id"
                                           cols="6" v-for="(sectionData) in listDatas">
                                        <v-expansion-panel>

                                            <div :key="sectionData.id">
                                                <div class="ml-10">

                                                    <v-checkbox :label="sectionData.reportName"
                                                                @change="updatedCheckSection(sectionData.id,sectionData.tickUntick)"
                                                                v-model="sectionData.tickUntick"></v-checkbox>
                                                </div>
                                            </div>

                                        </v-expansion-panel>
                                    </v-col>
                                </v-row>
                            </v-expansion-panels>

                        </form>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-row justify="center">
                        <v-btn @click="tableSectionSubmit" color="primary">{{$t('submit')}}</v-btn>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-expansion-panels class="my-8" v-model="panelData">

            <v-expansion-panel>
                <v-expansion-panel-header>{{$t('assignForm')}}</v-expansion-panel-header>
                <v-expansion-panel-content>
                    <v-container fluid>
                        <vue-good-table :columns="columns"
                                        :rows="rows"
                                        mode="remote"
                                        :totalRows="userData.totalRecords"
                                        :pagination-options="{ enabled: true,mode: 'records' }"
                                        @on-page-change="onPageChange"
                                        @on-sort-change="onSortChange"
                                        @on-column-filter="onColumnFilter"
                                        @on-per-page-change="onPerPageChange"
                                        styleClass="vgt-table condensed">
                            <template slot="table-column" slot-scope="props">
                                <span>
                                    {{ $t(props.column.label) }}
                                </span>
                            </template>
                            <template slot="table-row" slot-scope="props">
                                <span v-if="props.column.field == 'role'">
                                    <v-btn @click="dialogRoleModal(props.row)" class="mt-4">{{$t('assignrole')}}</v-btn>
                                </span>


                                <span v-else-if="props.column.field == 'actions'">

                                    <v-btn @click.stop="getItem(props.row)" color="primary">{{$t('edit')}}</v-btn>

                                </span>


                            </template>
                        </vue-good-table>


                    </v-container>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>

    </main>


</template>


<script>
    //import { required } from "vuelidate/lib/validators";
    import axios from "axios";
    import { mapGetters } from "vuex";
    //import SetupCard from '@/components/SetupCard';
    import AssignComponent from "./assignComponent";




    export default {

        props: ['ApiData'],
        computed: {
            ...mapGetters({
                userRole: 'getUserRole',
                usersData: 'getUserData',
            }),
            breadCrumbs() {
                return [
                    {
                        text: this.$t('dashboard'),
                        disabled: false,
                        to: `${this.usersData.dashBoard}`,
                        exact: true

                    },
                    {
                        text: this.$t('assignForm'),
                        disabled: true,
                    },
                ]
            }

        },

        data: () => ({
            user: {},
           
            dialogEditRow: false,
            ReportIds:[],
            columns: [
                {
                    label: 'Department Name',
                    field: 'departmentName',
                },

                { label: "actions", field: "actions" }
            ],
            rows: [],
            listDDLData: {
                companyList: [],
                departmentList: [],
                branchList: [],
                depoList: []
            },
            logData: {
                companyID: null,
                departmentID: null,
                branchID: null,
                depoID: null,

                year: "",
                reportLogID: 0
            },
            serverData: {
                companyID: null,
                departmentID: null,
                branchID: null,
                depoID: null,
                year: "",
                reportLogID: 0
            },
            storeData: {
                departmentID: null,
                companyType: "",
                assignCompanyID: null,
            },
            serverParams: {
                search: "",
                columnFilters: {},
                sort: [
                    {
                        field: "DepartmentName",
                        type: "desc"
                    }
                ],
                page: 1,
                perPage: 10
            },
            snackbar: {
                color: '',
                snackbar: false,
                text: '',
                timeout: 6000,
                isLoading: false,
                formModal: false,
            },
            dialogRow: false,
            count: 0,
            listDatas:[],
            validUser:true,

        }),
        created() {
            //this.breadCrumbData(),
                this.getDdlData(),
                this.getList(),
                this.loadCrumb(),
                this.validAssign()
        },
        methods: {
            loadCrumb() {
                axios.get("ReportSettings/GetReportYearList").then(response => {
                    this.yearList = response.data
                })

                axios.get('ReportSettings/DDLReportList').then(response => {
                    this.reportList = response.data
                })
            },
            updateParams(newProps) {
                this.serverParams = Object.assign({}, this.serverParams, newProps);
            },
            onResponse(){
              this.dialogRow= false
              this.dialogEditRow= false
            },
            onPageChange(params) {
                this.updateParams({ page: params.currentPage });
                this.getList();
            },

            onPerPageChange(params) {
                this.updateParams({ perPage: params.currentPerPage });
                this.getList();
            },
            dialogRoleModal(response) {
                console.log(response)
                this.userID = response.userID
                this.dialogRole = true;
            },
            onSortChange(params) {
                this.updateParams({
                    sort: [{
                        type: params[0].type,
                        field: params[0].field,
                    }],
                });
                this.getList();
            },

            onColumnFilter(params) {
                this.updateParams(params);
                this.getList();
            },
            getDdlData() {
                this.snackbar.loading = true;
                let param = {
                    Id: this.usersData.id,
                    type: this.usersData.role,
                };
                axios.post('Department/DDLDepartmentList', param).then(response => {
                    this.listDDLData.departmentList = response.data
                    this.snackbar.loading = false;
                })

            },
            reset() {
                let reportID = this.logData.reportID;
                this.logData = {
                    companyID: null,
                    departmentID: null,
                    branchID: null,
                    depoID: null,
                    reportID: reportID,
                    year: "",
                    reportLogID: 0
                },
                    this.status = {
                        isCompany: false,
                        isDepartment: false,
                    }
                this.selectedStatus = {
                    company: "",
                    branch: ""
                }
                this.$nextTick(() => {
                    this.$v.$reset()
                })
            },
            updateData() {

                this.count++
                this.dialogRow = true
            },
            getList() {

                this.snackbar.loading = true;
                let param = {
                    PageSize: this.serverParams.perPage == -1 ? this.userData.totalRecords : this.serverParams.perPage,
                    PageNo: this.serverParams.page,
                    OrderType: this.serverParams.sort[0].type,
                    OrderBy: this.serverParams.sort[0].field,
                    isActive: true
                };
                axios.post('AssignReport/AssignDepartmentReportList', param).then(response => {
                    console.log("dataaaaaaa",response)
                    this.rows = response.data.data
                    this.userData.totalRecords = response.data.totalCount
                    this.snackbar.loading = false;
                }).catch(res => {
                    console.log(res)
                })

            },
            getItem(item) {
                axios.get('AssignReport/GetAssignDepartmentReport/' + item.departmentID + '/' + item.companyType + '/' + item.assignCompanyID).then(response => {
                    this.dialogEditRow = true;
                    this.storeData.departmentID = item.departmentID;
                    this.storeData.companyType = item.companyType;
                    this.storeData.assignCompanyID = item.assignCompanyID;
                    this.listDatas = response.data;
                }).catch(res => {
                    console.log(res)
                })
            },
            breadCrumbData() {
                this.breadCrumbs = [
                    {
                        text: 'Dashboard',
                        disabled: false,
                        to: `${this.usersData.dashBoard}`,
                        exact: true

                    },
                    {
                        text: 'Assign Form',
                        disabled: true,
                    },
                ]

            },
            editItem(item) {
                axios.get('AssignReport/GetAssignDepartmentReport/', item.departmentID + '/' + item.companyType + '/' + item.assignCompanyID).then(response => {
                    this.rows = response.data.data
                    /* this.userData.totalRecords = response.data.totalCount*/
                    this.snackbar.loading = false;
                }).catch(res => {
                    console.log(res)
                })
            },
            tableSectionSubmit() {

                console.log('reportid', this.listDatas)
                //let postData = {
                //    ...this.logResponseData,

                //    ReportList: [...new Set(this.listDatas)],
                //}

                let data = {
                    departmentID: this.storeData.departmentID,
                    companyType: this.storeData.companyType,
                    assignCompanyID: this.storeData.assignCompanyID,
                    reportList: [...new Set(this.listDatas)],

                };
                console.log('final', data)
                axios.post("AssignReport/UpdateDepartmentAssignReport", data).then(response => {
                    console.log(response.data)
                    this.snackbar = true
                    this.servicesData.updated = true
                    this.$root.$emit("formResponse", this.servicesData);
                    this.servicesData.message = "Sub section visibility updated successfully"
                })
                this.dialogRow = false
                this.dialogEditRow = false
            },

            validAssign() {
                axios.get('AssignReport/ValidDepartmentAssign').then(response => {
                    console.log('papap', response)
                    if (response.data.existed == false) {
                        const baseurl = window.location.origin;
                        const redirectUrl = `${baseurl}/404`;   
                        window.location.href = redirectUrl;
                    }
                }).catch(res => {
                    console.log(res)
                })
            },
        },
        components: {
            //SetupCard,
            AssignComponent

        }
    };
</script>

<style lang="scss" scoped>

    .tbl {

        th {
            padding-top: 12px;
            padding-bottom: 12px;
            text-align: left;
            background-color: $main-color;
            color: white;
        }
    }

    table, td, th {
        border: 1px solid #ddd;
        text-align: left;
    }

    table {
        table-layout: fixed;
        border-collapse: collapse;
        width: 100%;
    }

    th, td {
        padding: 15px;
    }

    .tfoot {
        background-color: #d2d2d2;
    }

    .data-input {
        .v-input {
            max-width: 7.1em !important;
        }
    }

    input {
        max-width: 5.7em !important;
    }

    .employee-form-header {
        background-color: $main-color;
        height: 3em;
        padding: .6em;

        span {
            color: #ffffff;
            font-size: 1.4em;
        }
    }

    #form_card {
        text-align: center;
    }

    .box-border {
        border: 1px solid;
        padding: 1em;
    }
</style>
